import styled from 'styled-components';
import theme from '../../const/theme';

export const ServiceContainer = styled.div`
    max-width: 1270px;
    width: 100%;
    background-color: ${theme.COLORS.GRAY};
    border-radius: 50px;
    margin: 25px auto;
    padding: 3em;
    @media screen and (max-width: 768px){
        padding: 0;
        max-width: 100;

    }
`

export const ServicesTextWrapper = styled.div`
    text-align: center;
`

export const ServiceWrapper = styled.div`
    width: 100%;
`

export const ServiceRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    padding: 20px 80px;
    
    @media screen and (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        padding: 0 10px;
        align-items: center;
    }
`


export const ServicesCard = styled.div`
    background-color: ${({white})=> (white ? "#FFF" : "tranparent")};
    max-width: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    margin: 0;
    padding:30px 10px;
    margin: 0pt;
    height: 200px;
    border-radius: 10px;
    box-sizing: content-box;
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 0px 20px 1px rgba(0,0,200,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 1180px){
        max-width: 40%;
        width: 40%;
        margin-bottom: 20px;

    }

    @media screen and (max-width: 768px){
        max-width: 80%;
        width: 100%;
        margin-bottom: 20px;

    }
    
`

export const ServicesIcon = styled.img`
    height: 70px;
    margin-bottom: 10px;
`

export const ServicesH1 = styled.h1`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    margin-bottom: 25px;
    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 30px; 
        text-align: center;
        padding-top: 30px;

    }
`
export const ServicesH2 = styled.h2`
    font-family: 'Roboto-bold', sans-serif;     
    font-size: ${({small}) => (small ? '.9rem' : '1rem')};
    font-weight:500;
    margin-bottom: 10px;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: .8rem;
        text-align: center;
    }
`
export const ServicesP = styled.p`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: .65rem;
    text-align: left;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};
`